import { serviceroot } from '../config';
const serviceUrl = serviceroot +  "api/CustomerFeedback";

export const sendFeedBackAsync = (feedback) => {

    let body = {
        subject: "tarjousohjelma",
        freeText: feedback.comment,
        score: feedback.rating
    }
    let request = {
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    };
    return fetch(serviceUrl, request);
}